import { MunicipalityDependenciesFactory } from "./dependencies.factory";

export const municipalityEpicsDependencies = {
    municipalityService: MunicipalityDependenciesFactory.getMunicipalityService()
}
